<!-- End -->
<div class="content-wrapper table-full-bx">
  <div class="page-content recruiterpanel">

    <div class="row">
      <div class="col-lg-12">
        <div class="ibox ">
          <div class="ibox-body">
            <ol class="breadcrumb">
              <li class="breadcrumb-item"> <a href="javascript:void(0);" (click)="backToJob()"> Jobs </a> </li>
              <li class="breadcrumb-item active"> Job Detail </li>
            </ol>

            <div class="row">
              <div class="col-sm-12 col-md-10">
                <div class="basicbk">
                  <div class="innertext">
                    <p class="para6">{{allData?.JobPost?.newId || "-"}}</p>
                    <h6 class="heading-6">{{allData?.JobPost?.jobTitle || "-"}}</h6>
                  </div>
                  <div class="innertext">
                    <p class="para6">Location</p>
                    <h6 class="heading-6" *ngIf="allData?.JobPost?.workPlaceLocation != 'Remote'">
                      {{allData?.JobPost?.location || "-"}}
                    </h6>
                    <h6 class="heading-6" *ngIf="allData?.JobPost?.workPlaceLocation == 'Remote'">
                      -
                    </h6>
                  </div>
                  <div class="innertext">
                    <p class="para6">Post date</p>
                    <h6 class="heading-6">{{allData?.JobPost?.createdAt | date: "d/M/YYYY"}}</h6>
                  </div>
                  <div class="innertext">
                    <p class="para6">Schedule</p>
                    <h6 class="heading-6">{{allData?.JobPost?.schedulesName || "-"}}</h6>
                  </div>
                  <div class="innertext">
                    <p class="para6">User</p>
                    <h6 class="heading-6">{{allData?.recruiter?.name || "-"}}</h6>
                  </div>
                </div>
              </div>
              <div class="col-sm-12 col-lg-2 col-md-2 ">
                <div class="on-off">
                  <div>
                    <h6 class="heding-6">Position</h6>
                    <p class="green" *ngIf="allData?.JobPost?.isBlocked==0">Open</p>
                    <p class="green" *ngIf="allData?.JobPost?.isBlocked==1">Closed</p>
                  </div>
                  <label class="switch" *ngIf="allData?.JobPost?.isBlocked==0">
                    <input type="checkbox" [checked]="allData?.JobPost?.isBlocked==0"
                      (change)="allData?.JobPost?.isBlocked==0" disabled>
                    <span class="slider round" (click)="openModal(allData,jobStatus)"></span>
                  </label>
                  <label class="switch" *ngIf="allData?.JobPost?.isBlocked==1">
                    <span class="slider round" (click)="jobOpenStatus($event,allData?.JobPost?.id)"></span>
                  </label>
                </div>
              </div>
            </div>
            <!-- Checkbox -->

            <ul class="nav nav-pills job-list">
              <li class="active">
                <a href="javascript:void(0)">Applicants</a>
              </li>
              <li>
                <a href="javascript:void(0)" (click)="redirectToSuggestion()">Suggested candidates</a>
              </li>
              <li>
                <a href="javascript:void(0)" (click)="redirectToDetail()">Details</a>
              </li>
            </ul>
            <!-- searchbox -->
            <div class="flexbox">



              <div class="iboxcontent">
                <h3>Applicants</h3>

              </div>
              <div class="input-group-icon input-group-icon-left ">

                <div class="ibox-tools align-items-baseline">
                  <div class="col-list-right">
                    <ul>
                      <li>Filter By:</li>
                      <li class="services">
                        <select class="form-control" (change)="filterApply($event)">
                          <option value="all">All</option>
                          <option value="0">Pending</option>
                          <option value="1">Shortlisted </option>
                          <option value="2">Rejected</option>
                          <option value="3">On Hold</option>
                          <option value="4">BV not cleared</option>
                          <option value="5">Hired</option>

                        </select>
                      </li>
                    </ul>
                  </div>

                  <div class="col-list-right">
                    <form (ngSubmit)="searchFun()">
                      <div class="form-group">
                        <span class="input-icon input-icon-right font-16"><img src="assets/images/search.svg"></span>
                        <input type="text" [(ngModel)]="search" autocomplete="off"
                          class="form-control form-control-rounded form-control-solid" name="search" id="key-search"
                          placeholder="Search By Name/Email/Phone Number/Location/Applied by" />
                        <span *ngIf="search" class="closeSearch" (click)="clearSearch()">&times;</span>
                      </div>
                    </form>
                  </div>
                </div>


              </div>
            </div>
            <!-- end -->
            <!-- Table -->
            <div class="table-scroll table-wrapper table-responsive user-top">
              <table id="example" class="table table-bordered table-hover m-0 ">
                <thead>
                  <tr>
                    <th>Name </th>
                    <th>Email/Phone no.</th>
                    <th>Location</th>
                    <th>Applied by</th>
                    <th>Applied date</th>
                    <th>Last communicated</th>
                    <th class="width-auto">Status</th>
                    <th>Action</th>
                  </tr>
                </thead>


                <tbody>
                  <!-- 1 -->
                  <tr
                    *ngFor="let data of listingData | paginate: { id:'pagination', itemsPerPage: pagination.limit, currentPage: currentPage ,totalItems: pagination.totalItems};let i=index">
                    <td><a href="javascript:void(0);" (click)="redirectTo(data)" class="jobid">{{data.user?.name}}</a>
                    </td>
                    <td><a href="javascript:void(0);" style="text-transform:unset;" (click)="redirectTo(data)">{{data.user?.email}}
                        <br>{{data.user?.phoneNumber}}</a></td>
                    <td><a href="javascript:void(0);" (click)="redirectTo(data)">{{data.user?.location}}</a></td>
                    <td><a href="javascript:void(0);" (click)="redirectTo(data)">{{data.user?.name}}</a></td>
                    <td><a href="javascript:void(0);" (click)="redirectTo(data)">{{data.createdAt | date: "d/M/YYYY h:mm
                        a"}}</a></td>
                    <td><a href="javascript:void(0);" (click)="redirectTo(data)">{{data.updatedAt | date:
                        "d/M/YYYY"}}</a></td>
                    <td>
                      <div ngbDropdown>
                        <a class="icon dropdown-toggle dropdownlist" href="javascript:void(0);" data-toggle="dropdown"
                          role="button" aria-haspopup="true" aria-expanded="false" id="dropdown_profile_area"
                          ngbDropdownToggle>
                          <span *ngIf="data.status == 0">Pending</span>
                          <span *ngIf="data.status == 1">Shortlisted</span>
                          <span *ngIf="data.status == 2">Rejected</span>
                          <span *ngIf="data.status == 3">On Hold</span>
                          <span *ngIf="data.status == 4 && data.note != null">BV not cleared <img
                              src="../../../../assets/images/ic_note.svg" /></span>
                          <span *ngIf="data.status == 5 && allData?.JobPost?.isBlocked==0">Hired</span>
                          <img src="assets/images/ic_down.svg" alt="down arrow"> </a>
                        <ul class="dropdown-menu dropdown-menu-left dropdown-menu-animated dropdown-arrow "
                          ngbDropdownMenu>
                          <li *ngIf="data.status != 0"><a class="dropdown-item" href="javascript:void(0);"
                              (click)="status($event,data,0)">Pending</a></li>
                          <li *ngIf="data.status != 1"><a class="dropdown-item" href="javascript:void(0);"
                              (click)="status($event,data,1)">Shortlist</a></li>
                          <li *ngIf="data.status != 2"><a class="dropdown-item" href="javascript:void(0);"
                              (click)="status($event,data,2)">Reject</a></li>
                          <li *ngIf="data.status != 3"><a class="dropdown-item" href="javascript:void(0);"
                              (click)="status($event,data,3)">On Hold</a></li>
                          <li *ngIf="data.status != 4" (click)="status($event,data,4)"><a class="dropdown-item"
                              href="javascript:void(0);">BV not cleared</a></li>
                          <li *ngIf="data.status != 5 && allData?.JobPost?.isBlocked==0"
                            (click)="status($event,data,5)"><a class="dropdown-item"
                              href="javascript:void(0);">Hired</a></li>
                        </ul>
                      </div>
                    </td>

                    <td>
                      <div ngbDropdown>
                        <a class="icon dropdown-toggle dropdownlist" href="javascript:void(0);" data-toggle="dropdown"
                          role="button" aria-haspopup="true" aria-expanded="false" id="dropdown_profile_area"
                          ngbDropdownToggle><img src="assets/images/ic_three_dot.svg"></a>
                        <ul class="dropdown-menu dropdown-menu-left dropdown-menu-animated dropdown-arrow "
                          ngbDropdownMenu>
                          <li><a class="dropdown-item" href="javascript:;" (click)="openChatView(data)">Chat</a></li>
                          <li *ngIf="data.note != null"><a class="dropdown-item" href="javascript:void(0);"
                              (click)="viewNoteStatus($event,data,viewNotes)">View Note</a></li>
                          <li *ngIf="data.note == null"><a class="dropdown-item" href="javascript:void(0);"
                              (click)="noteStatus($event,data,addMore)">Create note</a></li>
                        </ul>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
              <div class="noDataFound" *ngIf="listingData == 0">
                <h2>No records found</h2>
              </div>
            </div>
            <!--  pagination  *ngIf="allJobs.length > 9" -->
            <div class="col-sm-12 p-0" *ngIf="totalCount>9">
              <ul class="pagination ">
                <pagination-controls id="pagination" (pageChange)="pageChanged($event)" previousText="&#60;"
                  nextText="Next" firstText="&#62;" lastText="Last"></pagination-controls>
              </ul>
            </div>
            <!-- end -->
          </div>
        </div>
      </div>
    </div>

  </div>
</div>

<ng-template #jobStatus>
  <div class="modal-body addModal text-left">
    <form [formGroup]="jobForm" (ngSubmit)="jobPostStatus()">
      <h4 class="uppercasetext">Are you sure you want to close this position?</h4>
      <div class="form-group">
        <label>Reason for closing job</label>
        <textarea class="form-control p-0" placeholder="Please write here" formControlName="reason"
          maxlength="2000"></textarea>
        <p class="para5 text-left m-0">{{jobForm?.value?.reason?.length}}/2000</p>
        <div class="text-danger" *ngIf="jobForm.controls['reason'].hasError('required') && showError">
          *Please Enter reason.
        </div>
      </div>
      <div class="form-group">
        <div class="custom-control custom-checkbox">
          <input type="checkbox" class="custom-control-input" id="customCheckBox1" formControlName="isNotify"
            [value]="1" [checked]="jobForm.value.isNotify == 1" (change)="jobForm.value.isNotify = 1">
          <label class="custom-control-label" for="customCheckBox1">Do you want to notify users?</label>
        </div>
      </div>
      <div class="d-flex">

        <div class="form-group">
          <a href="javascript:void(0);" class="planbtn greyBtn" (click)="modalRef?.hide()">Cancel</a>
        </div>
        <div class="form-group">
          <input type="submit" value="Close position" class="planbtn fill">
        </div>

      </div>
    </form>
  </div>
</ng-template>

<ng-template #addMore>
  <div class="modal-body addModal text-left">
    <form [formGroup]="form" (ngSubmit)="onSubmit()">
      <h4 class="uppercasetext">Create note for {{noteData?.user?.name}}</h4>
      <p class="para5 m-0 text-left">{{noteData?.user?.location}}</p>
      <p class="para5 m-0 text-left"><strong>Status:</strong>
        <span *ngIf="noteData?.status == 0">Pending</span>
        <span *ngIf="noteData?.status == 1">Short listed</span>
        <span *ngIf="noteData?.status == 2">Rejected</span>
        <span *ngIf="noteData?.status == 3">On Hold</span>
        <span *ngIf="noteData?.status == 4">BV not cleared </span>
      </p>
      <div class="form-group">
        <label>Note</label>
        <textarea class="form-control" placeholder="Enter Note here..." formControlName="note"
          maxlength="2000"></textarea>
        <p class="para5 text-left m-0">{{form?.value?.note?.length}}/2000</p>
      </div>
      <div class="d-flex">

        <div class="form-group">
          <a href="javascript:void(0);" class="planbtn greyBtn" (click)="modalRef?.hide()">Cancel</a>
        </div>
        <div class="form-group">
          <input type="submit" value="Save" class="planbtn fill">
        </div>

      </div>
    </form>
  </div>
</ng-template>
<ng-template #viewNotes>
  <div class="modal-body addModal text-left">
    <h4 class="uppercasetext">{{noteData?.user?.name}}</h4>
    <p class="para5 text-left m-0">{{noteData?.user?.location}}</p>
    <p class="para5 text-left m-0"><strong>Status:</strong>
      <span *ngIf="noteData?.status == 0">Pending</span>
      <span *ngIf="noteData?.status == 1">Short listed</span>
      <span *ngIf="noteData?.status == 2">Rejected</span>
      <span *ngIf="noteData?.status == 3">On Hold</span>
    </p>
    <p class="para5 text-left m-0"><strong>Note:</strong>
      <span>{{noteData?.note || "-"}}</span>
    </p>

    <div class="d-flex">

      <div class="form-group">
        <a href="javascript:void(0);" class="planbtn greyBtn mt-2" (click)="modalRef?.hide()">Cancel</a>
      </div>

    </div>
  </div>
</ng-template>